export const USER_ADDRESS_REQUEST = "USER_ADDRESS_REQUEST";
export const USER_ADDRESS_REQUEST_SUCCESS = "USER_ADDRESS_REQUEST_SUCCESS";
export const USER_ADDRESS_REQUEST_ERROR = "USER_ADDRESS_REQUEST_ERROR";

export const USER_ADDRESS_ADD_REQUEST = "USER_ADDRESS_ADD_REQUEST";
export const USER_ADDRESS_ADD_SUCCESS = "USER_ADDRESS_ADD_SUCCESS";
export const USER_ADDRESS_ADD_ERROR = "USER_ADDRESS_ADD_ERROR";

export const USER_ADDRESS_UPDATE_REQUEST = "USER_ADDRESS_UPDATE_REQUEST";
export const USER_ADDRESS_UPDATE_SUCCESS = "USER_ADDRESS_UPDATE_SUCCESS";
export const USER_ADDRESS_UPDATE_ERROR = "USER_ADDRESS_UPDATE_ERROR";

export const USER_ADDRESS_DELETE_REQUEST = "USER_ADDRESS_DELETE_REQUEST";
export const USER_ADDRESS_DELETE_SUCCESS = "USER_ADDRESS_DELETE_SUCCESS";
export const USER_ADDRESS_DELETE_ERROR = "USER_ADDRESS_DELETE_ERROR";
